import type { FieldValues, UseFormReturn } from 'react-hook-form';

import { applyServerErrors } from '@/business';
import { isApiError } from '@/shared/api';

/**
 * Applies a server error to the form fields it names and returns the form-level message, if any: the localized
 * error plus field errors that have no field here. Null when every problem was shown on a field.
 */
export function formLevelError<T extends FieldValues>(form: UseFormReturn<T>, error: unknown, paths: readonly string[]): string | null {
  const err = applyServerErrors(form, error, paths);
  if (!err) return null;
  const mappedAll = isApiError(error) && error.fieldErrors.length > 0 && err.messages.length === 0;
  return mappedAll ? null : [err.title, ...err.messages].join(' ');
}
